import React, {FC, useCallback, useEffect, useState} from 'react';

import Popup from 'components/__helpers/popup/popup';
import CmsPopup from 'components/popups/cmsPopup/cmsPopup';
import {Loader} from 'components/__helpers/loader/loader';
import {Z_INDEX} from 'constants/cssVariables';

import {contentPage} from 'libs/requests/cmsPage/cmsPage';
import {PRIVACY_POLICY} from 'constants/cmsContent/cmsContent';

import s from './privacyPolicy.scss';

export type PropsType = {
    onTogglePopup?: (isVisible: boolean) => void;
};

/**
 * Component for privacy policy popup and its trigger, it fetches popup content
 * @returns {React.ReactElement} component for privacy policy popup and its trigger
 */
export const PrivacyPolicy: FC<PropsType> = ({children, onTogglePopup}) => {
    const [isPopupVisible, setPopupVisible] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [popupContent, setPopupContent] = useState<string>('');
    useEffect(() => {
        contentPage.getContent(PRIVACY_POLICY).then(result => {
            setPopupContent(result.error ? result.message : result.content);
            setLoading(false);
        });
    }, []);

    const togglePopup = useCallback(() => {
        if (onTogglePopup) onTogglePopup(!isPopupVisible);
        setPopupVisible(!isPopupVisible);
    }, [isPopupVisible, onTogglePopup]);

    return (
        <>
            <button type="button" className={s.link} onClick={togglePopup}>
                {children}
            </button>
            <Popup
                visible={isPopupVisible}
                onClose={togglePopup}
                zIndex={Z_INDEX['--zIndex-overlay']}
            >
                <CmsPopup cms={popupContent} />
                {loading && (
                    <div className={s.loader}>
                        <Loader />
                    </div>
                )}
            </Popup>
        </>
    );
};
